module.exports = __webpack_public_path__ + "img/survey.6e0952f1.png";